module.exports = __webpack_public_path__ + "static/media/solo12.13529216.JPG";